const BASE_URL = "https://www.squaremigration.com";

/**
 * Freshness dates are explicit constants per route, not build-time timestamps.
 * Bump `modified` only when a page's content meaningfully changes.
 */
export type Freshness = { published: string; modified: string };

export function freshnessMeta({ published, modified }: Freshness) {
  return [
    { property: "article:published_time", content: published },
    { property: "article:modified_time", content: modified },
  ];
}

export function webPageSchemaScript(opts: {
  path: string;
  name: string;
  description: string;
  published: string;
  modified: string;
}) {
  const url = `${BASE_URL}${opts.path}`;
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${url}#webpage`,
      url,
      name: opts.name,
      description: opts.description,
      inLanguage: "en-US",
      datePublished: opts.published,
      dateModified: opts.modified,
      isPartOf: { "@type": "WebSite", name: "Square Migration", url: BASE_URL },
      publisher: { "@id": `${BASE_URL}/#organization` },
    }),
  };
}
